import { useTolgee } from '@tolgee/react'
import { useLayoutEffect } from 'react'
import { getNamespacesForRoute } from './namespaceConfig'

export function useRouteNamespaces(routeGroup: string): void {
  const tolgee = useTolgee()

  useLayoutEffect(() => {
    const namespaces = getNamespacesForRoute(routeGroup)

    for (const namespace of namespaces) {
      void tolgee.addActiveNs(namespace)
    }
  }, [routeGroup, tolgee])
}
